import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export const editCompanySchema = z.object({
  name: z.string().min(1),
  registrationNumber: z.string().min(1),
});

export type EditCompanyFormValues = z.infer<typeof editCompanySchema>;

export const useEditCompanyForm = (defaultValues: EditCompanyFormValues) => {
  const methods = useForm<EditCompanyFormValues>({
    mode: 'onTouched',
    resolver: zodResolver(editCompanySchema),
    defaultValues,
  });

  return methods;
};
